// extracted by mini-css-extract-plugin
export default {"h1-style":"jv3iVVac7ABZTbnbOTwI","h3-style":"SwR5vguq6fsN3yV584wT","p-style":"FMrLvPBMTfEjoo4rCQA8"};